module.exports = __webpack_public_path__ + "static/media/d6ru.f088d419.pdf";